import { render, staticRenderFns } from "./OSideBar.vue?vue&type=template&id=2891493a&scoped=true&"
import script from "./OSideBar.vue?vue&type=script&lang=js&"
export * from "./OSideBar.vue?vue&type=script&lang=js&"
import style0 from "./OSideBar.vue?vue&type=style&index=0&id=2891493a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2891493a",
  null
  
)

export default component.exports